import { useState } from 'react'
import { useHost, useView } from '@10000/react'
import { Body, Box, Button, Input } from '../'
import { subscriptions } from '../../../lookups'

export const Coupon = ({ onChange }) => {
  const { getCouponDetails } = useHost()
  const { subscription } = useView('tenant')
  const price = subscriptions[subscription.index]?.price

  const [code, setCode] = useState('')
  const [promotion, setPromotion] = useState(undefined)
  const [invalidCode, setInvalidCode] = useState(false)

  const updateCode = (e) => setCode(e.target.value.toUpperCase())

  const addCouponOnEnter = add => (e) => {
    if(e.key === 'Enter') {
      e.preventDefault()
      if(add) {
        return addCoupon()
      }
    }
  }

  const addCoupon = async () => {
    if(code === '') {
      return
    }

    const promotionResult = await getCouponDetails(code, 'usd')
    if(promotionResult !== null){
      setInvalidCode(false)
      setPromotion(promotionResult)
      onChange(promotionResult)
      setCode('')
    } else {
      setInvalidCode(true)
      onChange(undefined)
    }
  }

  const removeCoupon = () => {
    setPromotion(undefined)
    onChange(undefined)
  }

  const calculateTotal = () => {
    if(promotion === undefined) {
      return price
    }
    const amountOff = promotion.coupon?.amount_off ? (promotion.coupon.amount_off / 100) : 0
    const percentageOff = promotion.coupon?.percent_off ? 1 - (promotion.coupon.percent_off / 100) : 1
    return Math.max(((price - amountOff) * percentageOff), 0)
  }


  return (
    <Box fullWidth column gap={16}>
      <Box fullWidth gap={16} alignItems="end">
        <Input title="Coupon" value={code} onKeyDown={addCouponOnEnter(false)} onKeyUp={addCouponOnEnter(true)} onChange={updateCode} />
        <Button onClick={addCoupon} className="input-height">Add</Button>
      </Box>
      <Box gap={8}>
        {invalidCode &&
          <Body color="var(--red)">Invalid coupon code</Body>
        }
        {promotion &&
          <Body bold alt>{promotion?.code}</Body>
        }
        {promotion?.coupon?.amount_off &&
          <Box fullWidth textAlign="center">- ${(promotion.coupon?.amount_off/100) + ' off your total'}</Box>
        }
        {promotion?.coupon?.percent_off &&
          <Box fullWidth textAlign="center">- {promotion.coupon.percent_off + '% off your total'}</Box>
        }
        {promotion &&
          <Box cursor="pointer" onClick={removeCoupon}>
            <Body alt bold underline italic>Remove</Body>
          </Box>
        }
      </Box>
      <Box fullWidth column gap={8}>
        {promotion &&
          <Box justifyContent="space-between" fullWidth>
            <Body bold alt>Original Total</Body>
            <Body alt bold>${price}</Body>
          </Box>
        }
        <Box justifyContent="space-between" fullWidth>
          <Body bold alt>Total</Body>
          <Body size={32} alt bold>${calculateTotal()}</Body>
        </Box>
        <Box justifyContent="end" fullWidth>
          <Body size={14} bold lineHeight="100%">USD p/a</Body>
        </Box>
      </Box>
    </Box>
  )
}